export { createSanityAdapter, toSlugCandidates } from './adapter';
export type { SanityAdapterConfig } from './adapter';
export { createFetchQueryRunner } from './query-runner';
export type { SanityQueryRunner, FetchQueryRunnerConfig } from './query-runner';
export { createSanityClientRunner } from './sanity-client-runner';
export type { SanityClientRunnerConfig } from './sanity-client-runner';
export { isSanityEnabled, shouldUseSanityAdapter } from './is-sanity-enabled';
export type { SanityGuardInput } from './is-sanity-enabled';
export { createCmsProviderAdapter } from './provider-adapter';
export { familyEntryByRole, richTextByRole } from './family';

// Generated Sanity block types (from the migration bundle via TypeGen — see
// `sanity.types.gen.ts`). Re-exported so product code can derive its domain
// types from the schema instead of hand-mirroring it.
export type {
  Accordion,
  AddressFinder,
  Carousel,
  Centered,
  ChatLinks,
  ContentCard,
  ContentCategories,
  ContentCategory,
  ContentCardRebranded,
  ContractConfirmation,
  Article,
  Bucket,
  CreditWarningBar,
  ChatEntryPoint,
  CustomerRating,
  CustomerReview,
  CustomFormField,
  DialogWithButtonsField,
  Divider,
  DownloadContracts,
  DynamicPriceCardElectricityV2,
  FlourishChart,
  FocalPointImage,
  GenericForm,
  Hero,
  HeroCard,
  HeroCardRebranded,
  HeroRebranded,
  Image,
  LineUp,
  LinkCard,
  List,
  MegaMenu,
  MegaMenuDivision,
  MessageBar,
  MyEnvDisabledLandingPageCard,
  NewsletterFormIntegratedWithRevolution,
  NotificationField,
  NotificationBox,
  NotificationsBar,
  PaginatedContent,
  PersonalizationCookieController,
  PersonalizedTitleTextCTA,
  PersonalizedVideo,
  Price,
  PromoBox,
  QuickLinks,
  RadioGroupField,
  RegisterToNewsletterForm,
  RichText,
  RichTextEntry,
  TopTaskCTA,
  UsabillaFeedback,
  Section,
  ShareOnSocials,
  SimpleTable,
  SmeAddressFinder,
  SplitView,
  Table,
  TextImageRebranded,
  TextStreamer,
  TitleTextCTA,
  USPItem,
  Video,
  WarmthCheckAddressFinder,
  WarmthInterruptions,
} from './sanity.types.gen';

// Re-exported under a stable alias: TypeGen suffixes a type whose name another type in the bundle
// claims first, and the `ButtonLink` block was `ButtonLink_2` until the bundle replaced its nested
// `ButtonLink` link object with `GeneralLink`. Product code keeps one name through such renames.
export type { ButtonLink as ButtonLinkBlock } from './sanity.types.gen';

export { VisualEditing } from './VisualEditing';
export { createEditAttribute } from './edit-attribute';
// The bridge and a type only — never the hook: this barrel is imported statically, and the hook's
// `@sanity/visual-editing/react` and `@sanity/mutate` must stay in the bridge's lazy chunk.
export { SlotAdderBridge } from './SlotAdderBridge';
export { DISPATCH_FIELDS, NEVER_ENCODE, PRESENTATION_FIELDS, STRUCTURAL_FIELDS, stegaFilter } from './stega-filter';
